/* eslint max-len: 0 */
import React, { SVGProps } from "react";

const PricetagWhite = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.91681 5.89823C5.45876 5.89823 5.89808 5.45892 5.89808 4.91696C5.89808 4.37501 5.45876 3.9357 4.91681 3.9357C4.37486 3.9357 3.93555 4.37501 3.93555 4.91696C3.93555 5.45892 4.37486 5.89823 4.91681 5.89823Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.27088 0C1.46442 0 0 1.46442 0 3.27088V6.11207C0 6.97957 0.34461 7.81152 0.958018 8.42494L5.53724 13.0042C6.81462 14.2815 8.88561 14.2815 10.163 13.0042L13.0042 10.163C14.2815 8.88561 14.2815 6.81462 13.0042 5.53724L8.42494 0.958021C7.81152 0.34461 6.97957 0 6.11207 0H3.27088ZM1.30835 3.27088C1.30835 2.18701 2.18701 1.30835 3.27088 1.30835H6.11207C6.63256 1.30835 7.13173 1.51512 7.49977 1.88316L12.079 6.46241C12.8454 7.22881 12.8454 8.47142 12.079 9.23782L9.23782 12.079C8.47142 12.8454 7.22881 12.8454 6.46241 12.079L1.88316 7.49977C1.51512 7.13173 1.30835 6.63256 1.30835 6.11207V3.27088Z"
        fill="white"
      />
    </svg>
  );
};

PricetagWhite.displayName = "PricetagWhite";

export default PricetagWhite;
